import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function OversightCallout() {
    return (
        <section className="bg-white py-20" data-testid="oversight-callout">
            <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 mb-4 tracking-tight">
                        Want to See How the Oversight Works?
                    </h2>
                    <p className="text-[#6B7280] text-lg leading-relaxed mb-8">
                        The monthly timeclock audit is one of the most powerful parts of the program. Most agents have never seen this level of visibility into a remote hire. We walk you through it live on your diagnostic call.
                    </p>
                    <Link
                        to="/oversight"
                        className="inline-block border border-navy-900 text-navy-900 px-8 py-3.5 rounded-sm text-sm font-semibold tracking-wide hover:bg-navy-900 hover:text-white transition-colors duration-200"
                        data-testid="oversight-link"
                    >
                        See the Oversight Page
                    </Link>
                </motion.div>
            </div>
        </section>
    );
}
